export const getPaymentMode = (paymentMode) => {
  const fixedPaymentMode = paymentMode.toString().padStart(2, "0"); // Change 1-9 to 01-09
  switch (fixedPaymentMode) {
    case "01":
      return "Annual";
    case "02":
      return "Semi-Annual";
    case "04":
      return "Quarterly";
    case "08":
      return "Eighthly-Monthly";
    case "09":
      return "Ninthly-Monthly";
    case "10":
      return "Tenthly";
    case "11":
      return "Eleven-Monthly";
    case "12":
      return "Monthly";
    case "13":
      return "Every Four Weeks";
    case "16":
    case "18":
    case "20":
    case "22":
      return "Semi-Monthly";
    case "21":
      return "18 days";
    case "24":
      return "Twice a Month";
    case "26":
      return "Every Two Weeks";
    case "52":
      return "Seven Days";
    default:
      return fixedPaymentMode;
  }
};
